import { SVGProps } from 'react';

export type GoogleAdsIconProps = SVGProps<SVGSVGElement>;

/** Google Ads brand mark (the three-bar triangle). */
export const GoogleAdsIcon = ({ className, ...props }: GoogleAdsIconProps) => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M6.6 34.2 19.4 12c1.9-3.3 6.1-4.4 9.4-2.5 3.3 1.9 4.4 6.1 2.5 9.4L18.5 41.1c-1.9 3.3-6.1 4.4-9.4 2.5-3.3-1.9-4.4-6.1-2.5-9.4Z"
      fill="#FBBC04"
    />
    <path
      d="M28.9 9.5c-3.3-1.9-7.5-.8-9.4 2.5l-3.2 5.6 12.8 22.1c1.9 3.3 6.1 4.4 9.4 2.5 3.3-1.9 4.4-6.1 2.5-9.4L31.4 18.9l-.1-.1-2.4-9.3Z"
      fill="#4285F4"
    />
    <path
      d="M12.1 44.5a6.9 6.9 0 1 0 0-13.8 6.9 6.9 0 0 0 0 13.8Z"
      fill="#34A853"
    />
  </svg>
);
